var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"story-layout"},[_c('div',{staticClass:"story-layout__wrapper"},[_c('NuxtChild')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }